<template>
  <div>
    <b-container fluid class="px-5">
      <div class="mt-4 d-flex justify-content-between">
          <back-arrow title="Ajouter une note"/>
      </div>

      <b-card class="mt-2 mb-4 shadow-sm">

        <b-form @submit.stop.prevent="onSubmit">

          <b-row>
            <b-col lg="6">
              <b-form-group
                v-if="!hospitalizationId"
                id="animal-select"
                label="Animal *"
                label-for="animal-select"
                class="bold-label"
                :invalid-feedback="form.animal.invalidFeedback"
                :state="form.animal.state"
              >
                <AutoCompleteInput
                  id="animal-select"
                  placeholder="Sélectionner un animal"
                  :options="animalOptions"
                  @didSelect="didSelectAnimal"
                  @onReset="animalSelectInvalid = false"
                  :invalid="animalSelectInvalid"
                  invalid-message="Vous devez sélectionner un animal"
                  required
                />
              </b-form-group>
              <b-form-group
                v-if="!hospitalizationId"
                id="hospitalization-select"
                label="Hospitalisation *"
                label-for="hospitalization-select"
                class="bold-label"
                :invalid-feedback="form.hospitalization.invalidFeedback"
                :state="form.hospitalization.state"
              >
                <b-form-select
                  id="hospitalization-select"
                  v-model="form.hospitalization.value"
                  :options="hospitalizationOptions"
                  :state="form.hospitalization.state"
                  :disabled="form.animal.value === null"
                  required
                ></b-form-select>
              </b-form-group>
              <b-form-group
                id="title-input"
                label="Titre"
                label-for="title-input"
                class="bold-label"
                :invalid-feedback="form.title.invalidFeedback"
                :state="form.title.state"
              >
                <b-form-input
                  id="title-input"
                  v-model="form.title.value"
                  type="text"
                  maxlength="250"
                  :state="form.title.state"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                class="bold-label"
                label="Message"
                label-for="description-input"
                :state="form.description.state"
                :invalid-feedback="form.description.invalidFeedback"
              >
                <b-form-textarea
                  id="description-input"
                  class="mt-1"
                  v-model="form.description.value"
                  :state="form.description.state"
                ></b-form-textarea>
              </b-form-group>
            </b-col>
            <b-col lg="6">
              <div v-if="this.form.file.preview != null">

                <div
                  v-if="this.form.file.type === 'PHOTO'"
                  class="mt-2 position-relative text-right"
                >
                  <button @click="removeFile" class="btn-icon remove-photo-icon">
                    <trash-icon/>
                  </button>
                  <img
                    class="preview"
                    :src="this.form.file.preview"
                    alt="Aperçu"
                  >
                </div>

                <div
                  v-if="this.form.file.type === 'VIDEO'"
                  class="mt-2 position-relative text-right"
                >
                  <b-embed
                    type="video"
                    aspect="16by9"
                    controls
                  >
                    <source :src="this.form.file.preview">
                  </b-embed>
                  <b-card-text>
                    <button @click="removeFile" class="btn-icon remove-photo-icon">
                      <trash-icon/>
                    </button>
                  </b-card-text>
                </div>
              </div>

              <b-form-group
                v-if="this.form.file.preview == null"
                class="bold-label"
                label="Photo ou vidéo"
                label-for="file-input"
                :state="form.file.state"
                :invalid-feedback="form.file.invalidFeedback"
              >
                <b-form-file
                  id="file-input"
                  class="mt-1"
                  accept="image/jpeg, image/png, video/mp4, video/webm, video/quicktime"
                  placeholder="Photo ou vidéo..."
                  drop-placeholder="Glisser le fichier ici"
                  browse-text="Sélectionner"
                  v-model="form.file.value"
                  :state="form.file.state"
                ></b-form-file>
              </b-form-group>

            </b-col>
          </b-row>

          <div class="d-flex mt-4 justify-content-end">
            <b-button type="submit" variant="secondary" :disabled="sendButtonDisabled">Créer note</b-button>
          </div>
        </b-form>

      </b-card>
    </b-container>
  </div>
</template>

<script>

import api from '../../services/api';
import BackArrow from "../../components/BackArrow";
import AutoCompleteInput from "../../components/AutoCompleteInput";

export default {

  name: 'NoteCreate',

  components: {
    BackArrow,
    AutoCompleteInput
  },

  data() {

    return {
      hospitalizationId: this.$route.params.hospitalizationId, // Si l'utilisateur arrive depuis la partie "hospitalisation"
      previousRoute: null,
      animalSelectInvalid: false,
      sendButtonDisabled: false,

      form: {
        title: {
          state: null,
          invalidFeedback: null,
          value: null
        },
        animal: {
          state: null,
          invalidFeedback: null,
          value: null
        },
        hospitalization: {
          state: null,
          invalidFeedback: null,
          value: null
        },
        description:{
          state: null,
          invalidFeedback: null,
          value: null
        },
        file:{
          state: null,
          invalidFeedback: null,
          value: null,
          preview: null,
          type: null,
        }
      },
      animalOptions: [
        { value: null, text: 'Sélectionner un animal' },
      ],
      hospitalizationOptions: []
    }
  },

  mounted(){
    this.fetchData();
  },

  watch : {
    'form.file.value'() {
      if (this.form.file.value) {
        this.didAddFile()
      }
    }
  },

  beforeRouteEnter(to, from, next) {
    // Si on trouve l'info, retour à la page précédente. Sinon, retour à l'index.
    const previousRoute = (from && from.path !== '/') ? from.path : "/note/index"
    next(vm => vm.previousRoute = previousRoute)
  },

  methods: {

    fetchData() {
      if (!this.hospitalizationId) {
        this.fetchAnimals()
      }
    },

    fetchAnimals(){
      api
        .get(`/animal/getHospitalizedAnimals`)
        .then(response => {
          response.data.forEach(
            (element) => {
              this.animalOptions.push({value: element.id, text: `${element.name} (${element.user.name})`})
            }
          )
        })
    },

    fetchHospitalizations() {
      api
        .get(`/hospitalization?animalId=${this.form.animal.value}`)
        .then(response => {
          this.hospitalizationOptions = [{ value: null, text: 'Sélectionner une hospitalisation', disabled: true }]
          response.data.map(hospitalization => {
            this.hospitalizationOptions.push({value: hospitalization.id, text: `Hospitalisation du ${new Date(hospitalization.startDate).toLocaleDateString('fr-FR')} (#${hospitalization.id})`})
          })
        })
    },

    didSelectAnimal(value){
      this.form.animal.value = value
      if(value != null) this.fetchHospitalizations(value)
    },

    onSubmit() {
      if(this.form.animal.value === null && this.hospitalizationId === null){
        this.animalSelectInvalid = true
        return
      }
      this.sendButtonDisabled = true

      var headers = { 'content-type': 'multipart/form-data' }

      let data = new FormData()
      if (this.form.title.value && this.form.title.value.trim() !== "") {
        data.append('title', this.form.title.value)
      }
      data.append('hospitalizationId', this.hospitalizationId ? this.hospitalizationId : this.form.hospitalization.value)
      if (this.form.description.value && this.form.description.value.trim() !== "") {
        data.append('description', this.form.description.value)
      }
      if (this.form.file.value) {
        data.append(`file`, this.form.file.value)
      }

      api({
        method: 'POST',
        url: 'note',
        data: data,
        headers: headers
      })
        .then((response) => {
          if (this.hospitalizationId) {
            this.goToNoteForHospitalization()
          } else {
            this.goToNoteIndex()
          }
        })
        .catch((error) => {
          this.sendButtonDisabled = false
          if (error.response.status === 418) {
            const invalidField = error.response.data.invalidField
            this.form[invalidField]["state"] = false
            this.form[invalidField]["invalidFeedback"] = error.response.data.description
          }
        });
    },

    successToast(noteTitle) {
      this.$bvToast.toast(`Note ${noteTitle ? noteTitle : ''} ajoutée`, {
        autoHideDelay: 2000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true
      })
    },

    didAddFile(){
      this.form.file.preview = URL.createObjectURL(this.form.file.value)
      let extension = this.checkExtension(this.form.file.value.name).toUpperCase();
      this.form.file.type = "PHOTO"
      if(extension !== "JPG" && extension !== "JPEG" && extension !== "PNG"){
        this.form.file.type = "VIDEO"
      }
    },

    checkExtension(filename){
      return filename.split('.').pop();
    },

    removeFile(){
      this.form.file.preview = null;
      this.form.file.type = null;
      this.form.file.value = null;
      this.form.file.state = null;
      this.form.file.invalidFeedback = null;
    },

    goToNoteIndex() {
      this.$router.push({
        name: 'NoteIndex'
      }, () => {
        this.$nextTick(() => {
          this.successToast((this.form.title.value && this.form.title.value.trim() !== "") ? this.form.title.value : null)
        })
      })
    },

    goToNoteForHospitalization() {
      this.$router.push({
        name: 'NoteForHospitalization',
        params: {
          hospitalizationId: this.hospitalizationId
        }
      }, () => {
        this.$nextTick(() => {
          this.successToast((this.form.title.value && this.form.title.value.trim() !== "") ? this.form.title.value : null)
        })
      })
    }
  }
}
</script>

<style scoped>
.remove-photo-icon {
  position: absolute;
  top: 6px;
  right: 6px;
  background-color: var(--main-red);
  color: var(--main-white);
  border-radius: 50%;
  padding: 5px;
}
.remove-photo-icon:hover {
  background-color: var(--main-red-hover);
}

.preview {
  max-width: 100%;
  max-height: 480px;
}

</style>



// WEBPACK FOOTER //
// src/views/note/NoteCreate.vue